const ClaimSections = [
    '/claims',
    '/dashboard',
    '/users',
    '/reports',
    '/profile',
    '/company'
]

export const isClaimsSection = (path: string) => ClaimSections.some(s => path.startsWith(s));